import { TypedDocumentNode, gql } from '@apollo/client';
import classNames from 'classnames';
import styled from 'styled-components';

import { OverlapItems } from '@sorare/core/src/atoms/ui/OverlapItems';
import Avatar from '@sorare/core/src/components/user/Avatar';
import { Color } from '@sorare/core/src/style/types';

import { MembersRecap_rivalsUserGroup } from './__generated__/index.graphql';

const StyledOverlapItems = styled(OverlapItems)`
  max-width: calc(100vw - var(--quadruple-unit));
  overflow: hidden;
  & > * {
    height: 22px;
  }
`;

const AvatarWrapper = styled.div`
  outline: 2px solid var(--bgColor);
  border-radius: 50%;
  &.sm {
    border-width: 1px;
  }
`;

const Plus = styled.div`
  align-items: center;
  justify-content: center;
  outline: 2px solid var(--bgColor);
  background: var(--c-rivals-friendlies);
  font: var(--t-label-s);
  border-radius: var(--double-unit);
  padding: var(--half-unit);
  color: #101010;
  font-weight: bold;
`;

type Props = {
  userGroup: Nullable<MembersRecap_rivalsUserGroup>;
  size?: 'sm' | 'md';
  bgColor?: Color;
  className?: string;
};

export const MembersRecap = ({
  userGroup,
  size = 'md',
  bgColor = 'var(--c-neutral-100)',
  className,
}: Props) => {
  return (
    <div
      className={className}
      style={
        {
          '--bgColor': bgColor,
        } as React.CSSProperties
      }
    >
      <StyledOverlapItems>
        {userGroup?.memberships.slice(0, 5).map(membership => (
          <AvatarWrapper key={membership.id} className={classNames(size)}>
            <Avatar user={membership.user} rounded size={2.5} />
          </AvatarWrapper>
        ))}
        {userGroup && (userGroup?.membershipsCount || 0) > 5 && (
          <Plus className={size}>+{userGroup.membershipsCount - 5}</Plus>
        )}
      </StyledOverlapItems>
    </div>
  );
};

MembersRecap.fragments = {
  rivalsUserGroup: gql`
    fragment MembersRecap_rivalsUserGroup on RivalsUserGroup {
      slug
      id
      membershipsCount
      memberships {
        id
        user {
          slug
          ...Avatar_user
        }
      }
    }
    ${Avatar.fragments.user}
  ` as TypedDocumentNode<MembersRecap_rivalsUserGroup>,
};
